// extracted by mini-css-extract-plugin
export default {"menu":"ActionsMenu_menu__VIIab"};